var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Switch, Route } from 'react-router-dom';
import Detail from './Detail';
import theme, { mediaQueries } from '../../Theme';
import cxs from 'cxs/component';
let DetailRoutes = class DetailRoutes extends Component {
    render() {
        return (React.createElement(Wrapper, { style: {
            // marginBottom: theme.common.size.bar,
            } },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/detail/stretches/:id", component: props => React.createElement(Detail, Object.assign({}, props, { typeTicket: TypeTicket.Stretch })) }),
                React.createElement(Route, { exact: true, path: "/detail/cs/:id/:operator_id", component: props => React.createElement(Detail, Object.assign({}, props, { typeTicket: TypeTicket.CollaboratorStretch })) }),
                React.createElement(Route, { exact: true, path: "/detail/packets/:id", component: props => React.createElement(Detail, Object.assign({}, props, { typeTicket: TypeTicket.Packet })) }))));
    }
};
DetailRoutes = __decorate([
    inject('store')
], DetailRoutes);
export default DetailRoutes;
export const TypeTicket = {
    Stretch: 'stretch',
    CollaboratorStretch: 'collaboratorStretch',
    Packet: 'packet',
    CollaboratorPacket: 'collaboratorPacket',
};
const Wrapper = cxs('div')({
    overflowX: 'auto',
    height: `calc(100% - ${theme.common.size.bar}px)`,
    [mediaQueries.mobile]: {
        height: `calc(100% - ${theme.common.size.bar * 2}px)`,
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Detail/DetailRoutes.tsx
// module id = 40
// module chunks = 0